import React, { useEffect, useRef } from 'react';

/**
 * @param {Array} data datasets to be passed to chart instance
 * @param {String} title Used to identify a specific chart
 * @param {Object} options Describes the chart config
 * @param {String} type Defines the chart type e.g. line bar etc
 * @param {String} width Chart width in pixels
 * @param {String} height Chart height in pixels
 * @description A SFC component that renders ChartJS visualisations
 */

const GenericChart = ({ data, title, options, type, width, height }) => {
    const canvasRef = useRef(null);

    useEffect(() => {
        const context = canvasRef.current.getContext('2d');

        // ChartJS is imported/loaded as a 3rd party dependency via the ui-runtime bundle.
        // eslint-disable-next-line no-undef
        const chart = new Chart(context, {
            type,
            data,
            options,
        });

        // Cleanup the chart to prevent it from wildly animating when switching away and then back to Dashboard tab.
        return () => {
            chart.destroy();
        };
    }, [data]);

    return (
        <div style={{ position: 'relative' }}>
            <h2>{title}</h2>
            <canvas ref={canvasRef} width={width} height={height} data-testid="chart-canvas" />
        </div>
    );
};

export default GenericChart;
